export interface PaymentVerified {
    grabado: boolean;
    id: number | string;
    importe: number;
    pagado: boolean;
    tipo: string;
    closeIframe: boolean;
}


/**
 * Payment Verified
 *
 * @export
 * @class Payment Verified
 */
export class PaymentVerifiedHelper {

    static create(): PaymentVerified {
        return {
            grabado: false,
            id: '',
            importe: 0,
            pagado: false,
            tipo: '',
            closeIframe: false
        };
    }

    /**
     * Transform json into Payment Verified
     *
     * @static
     * @param {Object} object
     * @returns {Payment}
     *
     * @memberOf Payment
     */
    static transformFromApi(object: Object): PaymentVerified {
        const paymentVerified = PaymentVerifiedHelper.create();
        paymentVerified.grabado = object['PA_GRABADO'];
        paymentVerified.id = object['PA_ID'];
        paymentVerified.importe = object['PA_IMPORTE'];
        paymentVerified.pagado = object['PA_PAGADO'];
        paymentVerified.tipo = object['PA_TIPO'];
        return paymentVerified;
    }

    static setPaymentVerifiedKO(id: number | string) {
        return {
            grabado: false,
            id: id,
            importe: -1,
            pagado: false,
            tipo: '',
            closeIframe: true
        };
    }
}